// extracted by mini-css-extract-plugin
module.exports = {"textLink":"link_textLink__8HDc2","underline":"link_underline__hh4HC","breakWord":"link_breakWord__IesSC","noWrap":"link_noWrap__1evCc"};